import { useLocalStorage } from "@uidotdev/usehooks";

/**
 * useAuthTokens - React hook to manage the auth token in localStorage
 *
 * @returns {[string | null, (token: string | null) => void]} [authToken, setAuthToken]
 */
export const useAuthToken = () => useLocalStorage<string | null>("authToken", null);
